<template>
  <div class="hotco">
    <!-- <Broadcast class="broad" type="year" /> -->
    <div class="search-bar">
      <div class="input-wrapper"><Icon type="search" /><input type="search" placeholder="输入你要搜索企业" v-model="keyword" @search="search"></div>
      <span @click="$router.back()">取消</span>
    </div>
    <div class="colist" @scroll="scroll">
      <ul>
        <li v-for="(co, index) in coList" :key="index" @click="enterCo(co)">{{co.coname}}<Icon type="right"/></li>
      </ul>
      <Loading ref="loading" :noMoreMsg="noMoreMsg"/>
    </div>
    <BackHome />
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import BackHome from '@/components/BackHome'
import Loading from '../components/Loading.vue'
import Broadcast from '../components/Broadcast'

export default {
  name: 'HotCo',
  data() {
    return {
      keyword: '',
      coList: [],
      loading: false,
      pageIndex: 1,
      noMoreMsg: '未搜索到相关企业'
    }
  },
  methods: {
    search() {
      // 根据关键字过滤企业
      this.coList = []
      this.getCompany(1, this.keyword, ({list = [], state}) => {
        if(state === 1) {
          this.coList = list
        }
      })
    },
    enterCo(co) {
      this.$router.push('/company/' + co.coname)
    },
    scroll(e) {
      if(!this.loading && e.target.scrollHeight-e.target.scrollTop <= (e.target.clientHeight + 10)) {
        // 触底加载
        this.getCompany(this.pageIndex+1, this.keyword, ({list = [], state}) => {
          if(state === 1) {
            this.coList = this.coList.concat(list)
            this.loading = false;
            this.pageIndex += 1;
          }
        })
      }
    },
    // 获取公司列表并回调
    getCompany(page, keyword, callback) {
      // 开始加载
      this.loading = true
      if(page > 1) {this.noMoreMsg = '暂无更多企业'} else {this.noMoreMsg = '未搜索到相关企业'}

      if(this.$refs.loading) this.$refs.loading.startLoading()
      this.$http.get(`/getcompany?project_id=${this.$store.state.projectId}&pageindex=${page}&coname=${keyword}`)
      .then(res => {
        console.log(res)
        if(res.data.code === 1 && res.data.data.list.length > 0) {
          this.$refs.loading.loadSuccess()
          if(callback) callback({state: 1, list: res.data.data.list});
          if(this.$refs.loading) this.$refs.loading.loadSuccess()
        } else {
          if(callback) callback({state: 0})
          if(this.$refs.loading) this.$refs.loading.loadNoMore()
        }
      }).catch(err => {
        if(this.$refs.loading) this.$refs.loading.loadNoMore()
      }).finally(()=>{
        this.loading = false
      })
    }
  },
  created() {
    this.getCompany(1, '', ({list, state}) => {
      if(state)
      this.coList = list
    })
  },
  mounted() {
    this.$refs.loading.startLoading();
  },
  components: {
    Icon,BackHome,Loading, Broadcast
  }
}
</script>

<style lang="scss" scoped>
  .hotco {
    padding: 0 16px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #EDF2FA;
    .broad {margin-top: 16px}
    .search-bar { padding-right: 38px; flex-basis: 92px; display: flex; justify-content: space-between; align-items: center;
      font-size:28px; color:rgba(153,153,153,1);
      .input-wrapper { width:584px; height:60px; background:rgba(255,255,255,1); border-radius:8px; display: flex; align-items: center; padding-left: 42px;
        input { margin-left: 18px; width: 450px; border: none; outline: none; padding: 0;height: 60px;line-height: 60px;
          &::placeholder { color: #999999; font-size: 28px; }
        }
      }
      > span { font-size:28px; color:rgba(26,72,156,1); }
    }
    .colist { flex: 1; overflow-x: hidden; overflow-y: auto; -webkit-overflow-scrolling:touch; }
    li {
      padding: 0 32px; height:120px; background:rgba(255,255,255,1); border-radius:8px; margin-top: 16px; display: flex;
      justify-content: space-between; align-items: center; font-size:34px; color:rgba(51,51,51,1);
      &:first-child { margin-top: 0; }
    }
  }
</style>